import React from 'react'
import Helpers, { MAX_ATTEMPTS } from './HelpersFunctions'
import './Stats.css'

const Stats = ({ onClose }) => {
  const { streak, maxStreak, guessDist } = Helpers.getStats()

  const totalWins = Object.values(guessDist).reduce((a, b) => a + b, 0)
  const maxBarCount = Math.max(...Object.values(guessDist), 1)

  React.useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div className="stats-backdrop" onClick={onClose}>
      <div className="stats-modal" onClick={e => e.stopPropagation()}>
        <button className="stats-close" onClick={onClose} aria-label="Close">✕</button>

        <h2 className="stats-title">Statistics</h2>

        <div className="stats-summary">
          <div className="stats-stat">
            <span className="stats-stat__number">{totalWins}</span>
            <span className="stats-stat__label">Won</span>
          </div>
          <div className="stats-stat">
            <span className="stats-stat__number">{streak}</span>
            <span className="stats-stat__label">Streak</span>
          </div>
          <div className="stats-stat">
            <span className="stats-stat__number">{maxStreak}</span>
            <span className="stats-stat__label">Best streak</span>
          </div>
        </div>

        <h3 className="stats-section">Guess distribution</h3>

        {totalWins === 0 ? (
          <p className="stats-empty">No games completed yet. Come back after your first win.</p>
        ) : (
          <div className="stats-dist">
            {Array.from({ length: MAX_ATTEMPTS }, (_, i) => i + 1).map(n => {
              const count = guessDist[n] || 0
              const pct = Math.round((count / maxBarCount) * 100)
              return (
                <div key={n} className="stats-bar-row">
                  <span className="stats-bar-label">{n}</span>
                  <div className="stats-bar-track">
                    <div
                      className="stats-bar-fill"
                      style={{ width: `${Math.max(pct, count > 0 ? 8 : 0)}%` }}
                    >
                      {count > 0 && <span className="stats-bar-count">{count}</span>}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        )}

        <button className="stats-done" onClick={onClose}>Done</button>
      </div>
    </div>
  )
}

export default Stats
